import { type AuthToken } from '@reliance/types/models/Auth';
import { type Cdr, type CdrTranscription } from '@reliance/types/models/Cdr';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService } from '../types/ApiService';
import config from '../services/config';

export const cdr = (
  siteApi: ApiService,
  centralApi: ApiService,
  getToken: () => AuthToken,
) => ({
  get: (id) => {
    return siteApi.get(`/cdr/${id}`);
  },
  index: (params = {}): Promise<PaginatedResponse<Cdr>> => {
    return siteApi.get('/cdr', { params });
  },
  transcription: (id: number): Promise<CdrTranscription> => {
    return centralApi.get(`/cdr/${id}/transcription`);
  },
  recordingUrl: (recordingUrl) => {
    if (recordingUrl == null) {
      return null;
    }

    if (recordingUrl.indexOf('http') == -1) {
      recordingUrl = config.api.url + recordingUrl;
    }

    const separator = recordingUrl.indexOf('?') > -1 ? '&' : '?';
    return recordingUrl + separator + 'token=' + getToken().accessToken;
  },
  excelIndexUrl: (params) => {
    return siteApi.buildUrl('/cdr.xls', {
      ...params,
      token: getToken().accessToken,
    });
  },
  pdfUrl: (params = {}): string => {
    return siteApi.buildUrl('/cdr.pdf', {
      ...params,
      token: getToken().accessToken,
    });
  },
});
